// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import MainLayout from '../../layouts/MainLayout';
import Timer from '../../components/Timer';
import ProgressBar from '../../components/ProgressBar';
import Overview from './components/Overview';
import ChallengeMarkdown from './components/ChallengeMarkdown';
import ChallengeTimeUpDialog from './components/ChallengeTimeUpDialog';
import LoadingIcon from '../../components/LoadingIcon';
import { parseDuration, useQuery, getQueryParams, useUpdateEffect } from '../../lib/utility';
import { S } from './ChallengePageStyle';
import MemberContext from '../../contexts/MemberContext';
import WebSocketContext from '../../contexts/WebSocketContext';
import ChallengeSelector from '../../redux/selectors/ChallengeSelector';
import { CreditMethod, RunningLabSourceFrom } from '../../types/Model';
import { makeFooterVisibleHeight } from '../../redux/selectors/mainLayoutSelector/mainLayoutSelector';

import MultilineText from '../../components/MultilineText';
import { useParamsId } from '../../lib/utility';
import {
  useFetchChallengeInformation,
  useMarkdowns,
  useBuyChallenge,
  useTestChallenge,
  useEndChallenge,
  useLoadChallengeScroll,
  useSaveChallengeScroll,
  useIsNavigationScrolling,
  useUpdateRunningChallenge,
  useSendVisitChallenge
} from './hooks';
import QuestionnairePage from '../QuestionnairePage';
import { FormattedMessage } from 'react-intl';
import LeaderBoard from './components/LeaderBoard';
import CheckAnswer from './components/CheckAnswer';
import ScrollToAnswer from './components/ScrollToAnswer';
import Hint from './components/Hint';
import NoticeResetNotion from './components/NoticeResetNotion';
import ResetEnvButton from './components/ResetEnvButton';
import QuitChallengeButton from './components/QuitChallengeButton';
import Navigation from './components/Navigation';
import axios from 'axios';

const REFRESH_INTERVAL = 14 * 60 * 1000;
export interface WebSocketContextType {
  websocket?: WebSocket;
}

const ChallengePage = (): JSX.Element => {
  const creditMethod = CreditMethod.OrganizationCredit; // [TODO] selected by user
  const member = useContext(MemberContext);
  const websocket = useContext(WebSocketContext);

  const id = useParamsId();
  const query = getQueryParams(useQuery()) as { workshopId?: string, condition?: string, courseId?: string, iltCourseId?: string };
  const { condition } = query;

  // Navigation States
  const isNavigationScrolling = useIsNavigationScrolling();
  const [isClickNavigation, setClickNavigation] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const footerVisibleHeight = useSelector(makeFooterVisibleHeight());

  // challenge info states
  const challenge = useSelector(ChallengeSelector.makeChallengeByIdSelector(id));
  const isFetchingChallenge = useSelector(ChallengeSelector.makeIsFetchingChallenge());
  const challengeErrors = useSelector(ChallengeSelector.makeError());

  // challenge 是否還在運行 (從 member context 來，但弄成 hook 方便其他 component 渲染)
  const [isChallengeStart, setChallengeStart] = useState(() => {
    if (member.runningChallenge) {
      return true;
    } else {
      return false;
    }
  });

  // challenge 要 render 的 markdown 名稱（路徑）
  const [navigationClickToRender, setNavigationClickToRender] = useState(() => {
    if (isChallengeStart) {
      const cacheRenderMd = localStorage.getItem('mdPath');
      if (cacheRenderMd) {
        return cacheRenderMd;
      }
    } else {
      return ('README.md')
    }
  });

  const [navigationList, setNavigationList] = useState(() => {
    if (isChallengeStart && member.runningChallenge && member.runningChallenge.id === id) {
      const cacheNavigationList = localStorage.getItem('navigationList');
      if (cacheNavigationList) {
        return JSON.parse(cacheNavigationList);
      } else {
        localStorage.setItem('lastFocus', 'Scenario');
        localStorage.setItem('mdPath', 'README.md');
        return ([{ 'title': 'Overview' }]);
      }
    } else {
      // 還沒 Start
      return ([{ 'title': 'Overview' }]);
    }
  });

  const handleNavigation = (() => {
    if (challenge?.runningInfo?.markdownUrl) {
      const url = `${challenge.runningInfo.markdownUrl}/navigation.json`;
      axios.get(url, { withCredentials: true })
        .then((result) => {
          setNavigationList(result.data);
          localStorage.setItem('navigationList', JSON.stringify(result.data));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  })

  // 目前 user 點選的 navigation button
  const [navigationFocus, setNavigationFocus] = useState(() => {
    if (isChallengeStart) {
      return (localStorage.getItem('lastFocus'));
    } else {
      return ('Scenario');
    }
  });

  // 是否是最後一個 task (目前停留的標題 == navigationList 最後一個標題)
  const [isFinalTask, setFinalTask] = useState(() => {
    if (isChallengeStart && navigationFocus == navigationList[navigationList.length - 1].title) {
      return true;
    } else {
      return false;
    }
  });

  // markdown states
  const [isMarkdownShow, setIsMarkdownShow] = useState(false);
  const [markdowns, isMarkdownFetching] = useMarkdowns(challenge, isFetchingChallenge, navigationClickToRender);

  const [isChallengeTimeUpDialogShow, setIsChallengeTimeUpDialogShow] = useState(false);
  // Timer states
  const [endChallengeTime, setEndChallengeTime] = useState<Date>();
  const courseId = query.courseId ? parseInt(query.courseId, 10) : undefined;

  // Workshop States
  const workshopId = query.workshopId ? parseInt(query.workshopId, 10) : undefined;
  const iltCourseId = query.iltCourseId ? parseInt(query.iltCourseId, 10) : undefined;
  const { endTime } = challenge.relatedWorkshop || { endTime: new Date() };
  const fetchChallenge = useFetchChallengeInformation(id, { workshopId, iltCourseId });
  const refreshChallenge = useFetchChallengeInformation(id, { workshopId, preventLoading: true, iltCourseId });
  const visitChallenge = useSendVisitChallenge(id);
  // for questionnaire
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [challengeRecordId, setChallengeRecordId] = useState<number>();

  useEffect(() => {
    const interval = setInterval(() => {
      if (challenge.runningInfo) {
        console.log('refresh');
        refreshChallenge();
      }
    }, REFRESH_INTERVAL);
    handleNavigation();
    return () => {
      clearInterval(interval);
    }
  }, [refreshChallenge, challenge.runningInfo]);

  useEffect(() => {
    fetchChallenge();
    visitChallenge();
  }, [id, workshopId, courseId, iltCourseId]);

  useEffect(() => {
    fetchChallenge();
    if (isChallengeStart && navigationFocus == navigationList[navigationList.length - 1].title) {
      setFinalTask(true);
    } else {
      setFinalTask(false);
    }
  }, [navigationClickToRender]);

  useUpdateEffect(() => {
    if (challenge.runningInfo) {
      setIsMarkdownShow(true);
    } else {
      setIsMarkdownShow(false);
    }
  }, [challenge]);

  useEffect(() => {
    member.update();
  }, [challenge.runningInfo]);

  useEffect(() => {
    if (member.runningChallenge) {
      setChallengeRecordId(member.runningChallenge.recordId);
    }
  }, [member.runningChallenge]);

  useLoadChallengeScroll(markdowns);
  useSaveChallengeScroll(markdowns);

  const updateRunningChallenge = useUpdateRunningChallenge();

  const buyChallenge = useBuyChallenge(id, {
    creditMethod,
    workshopId,
    courseId,
    iltCourseId,
    success: () => {
      websocket.connectWebsocket();
      fetchChallenge();
      setChallengeStart(true);
      setNavigationFocus('Scenario');
      localStorage.setItem('lastFocus', 'Scenario');
      localStorage.setItem('mdPath', 'README.md');
      localStorage.removeItem('progressComplete');
      localStorage.removeItem('progressCount');
    },
    onError: () => {
      updateRunningChallenge({
        id,
        sourceFrom: workshopId ? RunningLabSourceFrom.Workshop : RunningLabSourceFrom.Ilt,
        sourceId: workshopId ? workshopId : iltCourseId,
      })
    },
  });

  const testChallenge = useTestChallenge(id, {
    success: () => {
      websocket.connectWebsocket();
      fetchChallenge();
      setChallengeStart(true);
      setNavigationFocus('Scenario');
      localStorage.setItem('lastFocus', 'Scenario');
      localStorage.setItem('mdPath', 'README.md');
    },
    onError: () => {
      updateRunningChallenge({
        id,
        sourceFrom: RunningLabSourceFrom.Test,
        sourceId: undefined,
      })
    }
  });

  const endChallenge = useEndChallenge(id, () => {
    fetchChallenge();
    resetAllState();
  });

  const handleBuyChallenge = () => {
    localStorage.removeItem('challengeScrollY');
    setEndChallengeTime(undefined);
    setCurrentIndex(0);
    updateRunningChallenge({ id });
    buyChallenge();
  }

  const handleTestChallenge = () => {
    testChallenge();
  }

  const resetHintUnlockStatus = () => {
    navigationList.map((item: any) => {
      if (item.hints) {
        item.hints.map((hintItem: any) => {
          localStorage.removeItem(hintItem.path);
        })
      }
    })
  }

  const resetTaskCompleteStatus = () => {
    navigationList.map((item: any) => {
      if (item.title) {
        localStorage.removeItem(item.title+' Complete');
      }
    })
  }

  const resetAllState = () => {
    resetTaskCompleteStatus();
    resetHintUnlockStatus();
    setNavigationFocus('Overview');
    setNavigationClickToRender(() => {
      localStorage.removeItem('mdPath');
      return 'README.md';
    });
    setChallengeStart(false);
    localStorage.removeItem('lastFocus');
    localStorage.removeItem('navigationList');
    localStorage.removeItem('progressComplete');
    localStorage.removeItem('progressCount');
    websocket.disconnectWebsocket();
  }

  const handleStartTaskButton = () => {
    setNavigationFocus('Task 1');
    const mdPath = 'task1/README.md';
    setNavigationClickToRender(() => {
      localStorage.setItem('mdPath', mdPath);
      return mdPath;
    });
    localStorage.setItem('lastFocus', 'Task 1');
  }

  const handleEndChallenge = () => {
    setEndChallengeTime(new Date());
    endChallenge();
    if (condition !== 'Test') {
      setShowQuestionnaire(true);
    }
  }

  const handleTimeUp = () => {
    setIsChallengeTimeUpDialogShow(true);
    setIsMarkdownShow(false);
    resetAllState();
  }

  const handleCloseChallengeTimeUpDialog = () => {
    setIsChallengeTimeUpDialogShow(false);
    fetchChallenge();
    if (condition !== 'Test') {
      setShowQuestionnaire(true);
    }
  }

  useEffect(() => {
    websocket.connectWebsocket()
  }, [])

  if (showQuestionnaire) {
    const basicInfo: any = {
      memberId: member.id,
      sourceId: workshopId ? workshopId : courseId ? courseId : iltCourseId ? iltCourseId : null,
      sourceFrom: workshopId ? 'workshop' : courseId ? 'onlineCourse' : iltCourseId ? 'iltCourse' : 'own',
      handsOnType: 'challenge',
      handsOnId: id,
      handsOnRecordId: challengeRecordId,
    }
    return (
      <MainLayout>
        <S.PopMask>
          <S.QuestionnaireContainer>
            <QuestionnairePage basicInfo={basicInfo} setShowQuestionnaire={setShowQuestionnaire}/>
          </S.QuestionnaireContainer>
        </S.PopMask>
      </MainLayout>
    )
  }

  if (isFetchingChallenge && !challenge.runningInfo) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <LoadingIcon size={20} />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (challengeErrors) {
    return (
      <MainLayout>
        <S.ChallengeErrorContainer>
          <S.ChallengeErrorForbiddenImage alt="challenge-error" />
          <S.ErrorText><FormattedMessage id="E038" /></S.ErrorText>
          {/* <S.ErrorText>{JSON.stringify(challengeErrors)}</S.ErrorText> */}
          <S.ErrorButton as={Link} to={'/challenges'} ><FormattedMessage id="E016" /></S.ErrorButton>
        </S.ChallengeErrorContainer>
      </MainLayout>
    );
  }

  const renderRunning = (): JSX.Element | undefined => {
    if (challenge.runningInfo) { // This challenge is running
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{
              <Timer
                startedTime={new Date(challenge.runningInfo.startTime)}
                endLabTime={endChallengeTime}
                duration={challenge.duration}
                onTimesUp={handleTimeUp}
              />}
            </S.TimerDurationText>
            <S.StartButton as={'a'} href={challenge.runningInfo.labInfo.loginLink} target="_blank"><FormattedMessage id={challenge.code === 'AWS' ? 'E012' : 'E012-2'} /></S.StartButton>
          </S.StartStopContainer>
          <S.QuitOrResetContainer>
            <QuitChallengeButton handleEndChallenge={handleEndChallenge}/>
            {/* For Future
            <ResetEnvButton />
            <NoticeResetNotion />
            */}
          </S.QuitOrResetContainer>
          <ProgressBar />
        </>
      )
    }

    if (!member.isLoading && member.runningLab) { // Other lab is running
      const query = member.runningLab.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningLab.sourceId}` :
        member.runningLab.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningLab.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningLab.sourceId}` : '';
      const url = `/labs/${member.runningLab.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(challenge.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E040" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="E009" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="E010" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }

    if (!member.isLoading && member.runningChallenge) { // Other challenge is running
      const query = member.runningChallenge.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningChallenge.sourceId}` :
        member.runningChallenge.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningChallenge.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningChallenge.sourceId}` : '';
      const url = `/challenges/${member.runningChallenge.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(challenge.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E040" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="E009" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="E041" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }

    if (!member.isLoading && member.runningExam) { // Other exam is running
      const query = member.runningExam.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningExam.sourceId}` :
        member.runningExam.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningExam.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningExam.sourceId}` : '';
      const url = `/exams/${member.runningExam.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(challenge.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E040" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="K014" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="K016" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }
  }

  const renderCreditBuyCondition = () => {
    if (challenge.costCredit) {
      const memberCredit = (creditMethod === CreditMethod.OrganizationCredit ? member.organizationCredit : member.organizationCredit) || 0;
      const isEnough = challenge.costCredit <= memberCredit;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(challenge.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={!isEnough}><FormattedMessage id="E039" /></S.StartButton>
            {isEnough && (
              <S.ConfirmStartContainer>
                <S.ConfirmStartTitle><FormattedMessage id="E003" values={{ credit: challenge.costCredit }} /></S.ConfirmStartTitle>
                <S.StartButton onClick={handleBuyChallenge}><FormattedMessage id="E068" /></S.StartButton>
              </S.ConfirmStartContainer>
            )}
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.CreditAmount>
              <FormattedMessage id="E005" values={{ credit: challenge.costCredit, creditEl: <S.Credit>{challenge.costCredit}</S.Credit> }} />
              <S.CreditNotion />
            </S.CreditAmount>
            <S.DescriptionText>
              {<FormattedMessage id={isEnough ? 'E006' : 'E007'} values={{ credit: memberCredit, creditEl: <S.DescriptionCreditText>{memberCredit}</S.DescriptionCreditText> }} />}
            </S.DescriptionText>
            {
              !isEnough && (
                <S.DescriptionText>
                  {member.organizationId ? (
                    <FormattedMessage id="E008" values={{ br: <br />, managerEmail: <S.DescriptionEmailText href={`mailto:${challenge.organizationContactEmail}`}>{challenge.organizationContactEmail}</S.DescriptionEmailText> }} />
                  ) : (
                    null
                    // <>請購買 Credit 以繼續</> /**未來有做B2C的話要補這塊 */
                  )}
                </S.DescriptionText>
              )
            }
          </S.DescriptionContainer>
        </>
      )
    }
  }

  const renderBuying = (): JSX.Element | null => {
    if (isFetchingChallenge || isMarkdownFetching) {
      return null;
    }
    if (condition === 'Test' && member.isManager) {
      return (
        <S.StartStopContainer>
          <S.TimerDurationText>{parseDuration(challenge.duration).all}</S.TimerDurationText>
          <S.StartButton onClick={handleTestChallenge}>測試挑戰</S.StartButton>
        </S.StartStopContainer>
      )
    }

    if (workshopId || iltCourseId) {
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(challenge.duration).all}</S.TimerDurationText>
            <S.StartButton onClick={handleBuyChallenge}><FormattedMessage id="E040" /></S.StartButton>
          </S.StartStopContainer>
        </>
      )
    } else {
      return (<>{renderCreditBuyCondition()}</>)
    }
  }

  const renderMainContent = (): JSX.Element => {

    return (
      <>
        <Overview
          isClickNavigation={isClickNavigation}
          onExpanded={() => setClickNavigation(false)}
          currentIndex={currentIndex}
        ><MultilineText text={challenge.overview} /></Overview>
        {!isChallengeStart && <LeaderBoard />}
        {
          isMarkdownFetching ? (<LoadingIcon size={10} />) : (
            challenge.runningInfo && (
              <>
                <S.CollapseTransition visible={isMarkdownShow}>
                  {isChallengeStart && navigationFocus !== 'Scenario' && <CheckAnswer isFinalTask={isFinalTask} handleEndChallenge={handleEndChallenge} navigationFocus={navigationFocus} setNavigationClickToRender={setNavigationClickToRender} setNavigationFocus={setNavigationFocus} ></CheckAnswer>}
                  <ChallengeMarkdown
                    isClickNavigation={isClickNavigation}
                    onExpanded={() => setClickNavigation(false)}
                    isNavigationScrolling={isNavigationScrolling}
                    currentIndex={currentIndex}
                    markdowns={markdowns}
                    baseUrl={challenge.runningInfo.markdownUrl}
                    challengePassword={challenge.runningInfo.labInfo.password}
                    onIndexChange={setCurrentIndex}
                  />
                  {isChallengeStart && navigationFocus !== 'Scenario' && <Hint challenge={challenge} isChallengeStart={isChallengeStart}></Hint>}
                  {navigationFocus == 'Scenario' && <S.Button onClick={handleStartTaskButton}><FormattedMessage id="E067" /></S.Button>}
                </S.CollapseTransition>
              </>
            )
          )
        }
      </>
    )
  }

  return (
    <MainLayout>
      <S.Container inWorkshop={workshopId !== undefined}>
        <S.NavigationContainer inWorkshop={workshopId !== undefined} style={{ bottom: footerVisibleHeight + 'px' }}>
          {workshopId && <S.WorkshopLabel endTime={endTime} />}
          <Navigation isChallengeStart={isChallengeStart && member.runningChallenge && member.runningChallenge.id === id} navigationList={navigationList} setNavigationList={setNavigationList} navigationFocus={navigationFocus} setNavigationFocus={setNavigationFocus} setNavigationClickToRender={setNavigationClickToRender} />
        </S.NavigationContainer>
        <S.WrapperContent>
          <S.ChallengeName>{challenge.name}</S.ChallengeName>
          { isFetchingChallenge ? (
            <S.MarkdownLoadingContainer>
              <LoadingIcon size={20} />
            </S.MarkdownLoadingContainer>
          ) : renderMainContent() }
        </S.WrapperContent>
        <S.WrapperSidebar inWorkshop={workshopId !== undefined}>
          {member.runningLab || member.runningChallenge || member.runningExam ? renderRunning() : renderBuying()}
        </S.WrapperSidebar>
      </S.Container>
      {isChallengeStart && <ScrollToAnswer />}
      <ChallengeTimeUpDialog showDialog={isChallengeTimeUpDialogShow} closeDialog={handleCloseChallengeTimeUpDialog} />
    </MainLayout>
  );
}

export default ChallengePage;
